import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import sensor from 'components/sensor';
import Modal, { Header, Content } from 'components/modal';
import Link from 'components/link';
import Button from 'components/button';
import { iconTypes } from 'components/icon';

import linksBild from 'src-sites/bild/links';
import linksDomik from 'src-sites/domik/links';

import translates from './comment-rules-i18n.json';

const classes = new Bem('commentRules');

/**
 * === CommentRules Component ===
 *
 * Рендерит Правила комментирования, на телефоне превращается в иконку
 *
 */

@sensor
@I18nHoc(translates)
export default class CommentRules extends Component {
  static propTypes = {
    className: PropTypes.string,
    dataView: PropTypes.oneOf(['btnPageComment', 'btnPageCommentReply'])
  };

  constructor(...args) {
    super(...args);
    this.onUpdateComponent = this.onUpdateComponent.bind(this);
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onResize = this.onUpdateComponent;
    this.__PROJECT__ = __CLIENT__ ? window.__PROJECT__ : global.__PROJECT__;

    this.state = {
      phone: false,
      showRulesModal: false
    };
  }

  componentDidMount() {
    this.onUpdateComponent(this.sensor.getRuntime());
  }

  onUpdateComponent({ media: { phone } = {} }) {
    if (phone !== this.state.phone) this.setState({ phone });
  }

  onOpenModal() {
    this.setState(prevState => ({ showRulesModal: !prevState.showRulesModal }));
  }

  render() {
    const { i18n } = this;
    const { className, dataView } = this.props;
    const { phone, showRulesModal } = this.state;
    let linkUa = '';

    if ( this.__PROJECT__ === 'bild' ) {
      linkUa = (
        <Link
          {...classes('link')}
          builder={linksBild.sectionBild}
          builderProps={{ title: 'bild.ua' }}
          inlineBlock
        >
          <span {...classes('linkContent')}>
            <span {...classes('text')} children="Bild.ua" />
          </span>
        </Link>
      );
    }
    if ( this.__PROJECT__ === 'domik' ) {
      linkUa = (
        <Link
          {...classes('link')}
          builder={linksDomik.sectionDomik}
          builderProps={{ title: 'domik.ua' }}
          inlineBlock
        >
          <span {...classes('linkContent')}>
            <span {...classes('text')} children="Domik.ua" />
          </span>
        </Link>
      );
    }

    return (
      <div
        {...classes({
          modifiers: { [dataView]: dataView },
          extra: className
        })}
      >
        <Button
          {...classes('btn')}
          title={i18n('commentingRules')}
          label={!phone && i18n('commentingRules')}
          iconType={phone && iconTypes.moreLabel}
          onClick={this.onOpenModal}
        />
        {showRulesModal &&
          <Modal
            {...classes('modal')}
            size="big"
            onCloseRequired={this.onOpenModal}
            renderModal
          >
            <Header closeButton>{i18n('commentingRules')}</Header>
            <Content addPaddingB>
              <div {...classes('modalContent')}>
                <Trans lang="ru">
                  <div {...classes('content')}>
                    <div>
                      <span {...classes('text')} children="Мы ценим и охраняем каждое сообщение пользователя, опубликованное в рамках правил." />
                    </div>
                    <br />
                    <div>
                      <span {...classes('text', 'bold')} children="Мы приветствуем:" />
                    </div>
                    <ul {...classes('ul', 'check')}>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Дружеский тон общения" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Взаимное уважение" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Аргументы в диалоге" />
                      </li>
                    </ul>
                    <br />
                    <div>
                      <span {...classes('text', 'bold')} children="Мы не приветствуем:" />
                    </div>
                    <ul {...classes('ul', 'check')}>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Рекламу" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Оскорбления" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Нарушение Закона" />
                      </li>
                    </ul>
                    <br />
                    <div>
                      <span {...classes('text')}>
                        Любое сообщение, в котором нарушаются правила, может быть удалено или отредактировано. Команда {linkUa} не отвечает за достоверность размещённой посетителями информации.
                      </span>
                    </div>
                    <br />
                  </div>
                </Trans>
                <Trans lang="ua">
                  <div {...classes('content')}>
                    <div>
                      <span {...classes('text')} children="Ми цінуємо і охороняємо кожне повідомлення користувача, опубліковане в рамках правил." />
                    </div>
                    <br />
                    <div>
                      <span {...classes('text', 'bold')} children="Ми вітаємо:" />
                    </div>
                    <ul {...classes('ul', 'check')}>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Дружній тон спілкування" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Взаємну повагу" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Аргументи в діалозі" />
                      </li>
                    </ul>
                    <br />
                    <div>
                      <span {...classes('text', 'bold')} children="Ми не вітаємо:" />
                    </div>
                    <ul {...classes('ul', 'check')}>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Рекламу" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Образи" />
                      </li>
                      <li {...classes('li')}>
                        <span {...classes('text')} children="Порушення закону" />
                      </li>
                    </ul>
                    <br />
                    <div>
                      <span {...classes('text')}>
                        Будь-яке повідомлення, в якому порушуються правила, може бути видалено або змінено. Команда {linkUa} не відповідає за достовірність розміщеної відвідувачами інформації.
                      </span>
                    </div>
                    <br />
                  </div>
                </Trans>
                {/* TODO: old rules
                {`Правила комментирования в разделах:

                Запрещены:
                1. Оскорбления в любой форме или неуважительный стиль общения.
                2. Реклама (или скрытая реклама), коммерция, ссылки уводящие
                пользователей на сайты аналогичной тематики.
                3. Неудобный для чтения Ник или текст (включённый Caps Lock,
                транслит, копипаст неудобного формата, несоблюдение пунктуации и
                т.п.)
                5. Провокационный характер сообщений, пропаганда насилия,
                разжигание расовой, национальной или религиозной розни.
                6. Разглашение информации личного характера участников форума
                без их согласия.
                7. Сообщения, которые не относятся к теме (оффтоп), дублируют
                сообщения и информацию (даббл-постинг), "замусоривают" тему
                (флуд).
                8. "Голые" ссылки без комментария или краткого заголовка.

                Дополнительные требования для статей "Авторская аналитика и
                новости ©":
                В этом разделе есть обязательное требование аргументации и
                работает повышенная защита от флуда.
                Мы ценим Вашу точку зрения, подкреплённую фактами и аргументами
                - такие сообщения не удаляются.

                Любое сообщение, в котором нарушаются правила, может быть
                удалено или отредактировано.
                Администрация не несет ответственности за достоверность
                размещённой посетителями информации.`}
                */}
              </div>
            </Content>
          </Modal>
        }
      </div>
    );
  }
}
